import { useAppSelector } from '../../stateManagement/hooks/redux';
import ContentHeader from '../../widgets/contentHeader/ContentHeader';
import TransportObjectInfoSection from '../../widgets/transport/transportObjectInfoSection/TransportObjectInfoSection';

// Страница отображения информации о пользователе
export function TransportNowObjectPage() {

    const stateNumber = useAppSelector(state => state.transportObjectInfo.transportObjectInfoStateNumber)

    return (
        <>
            <ContentHeader title={stateNumber && `Карточка транспортного средства «${stateNumber}»`} />
            <TransportObjectInfoSection type="now" />
        </>
    );
}

